import axios from "axios";
import { api_url } from "../utils/config";
const api = axios.create({
  baseURL: `${api_url}/api`,
  withCredentials: true,
});

// attach customer token automatically if present
api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("customerToken");
      if (token) {
        config.headers = config.headers || {};
        config.headers["authorization"] = `Bearer ${token}`;
      }
    } catch (err) {
      // ignore
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export default api;
